import React, { useCallback, useMemo } from 'react';
import {
  Popover, PageHeader, Row, Col,
} from 'antd';
import PropTypes from 'prop-types';
import { SettingOutlined } from '@ant-design/icons';
import OnTraccrButton from '../../common/buttons/OnTraccrButton';
import OnTraccrCheckbox from '../../common/inputs/OnTraccrCheckbox';
import { OPTIONAL_SOV_COLUMN_OPTIONS } from './ScheduleOfValuesColumns';

export default function ScheduleOfValuesColumnChanger({
  value,
  onChange,
}) {
  const selectedSet = useMemo(() => new Set(value), [value]);

  const onToggle = useCallback(
    (key) => (newChecked) => {
      if (newChecked) {
        if (selectedSet.has(key)) return;
        onChange([...value, key]);
      } else {
        onChange(value.filter((v) => v !== key));
      }
    },
    [value, onChange, selectedSet],
  );

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      content={(
        <div style={{ width: 175 }}>
          <Row>
            <PageHeader
              title="Columns"
              style={{ padding: 0, marginBottom: 5, fontFamily: 'raleway-medium' }}
            />
          </Row>
          <Col>
            {OPTIONAL_SOV_COLUMN_OPTIONS.map(({ label, value: colKey }) => (
              <Row key={colKey}>
                <OnTraccrCheckbox
                  onChange={onToggle(colKey)}
                  value={selectedSet.has(colKey)}
                  label={label}
                />
              </Row>
            ))}
          </Col>
        </div>
      )}
    >
      <OnTraccrButton
        title="Columns"
        icon={<SettingOutlined />}
        type="cancel"
      />
    </Popover>
  );
}

ScheduleOfValuesColumnChanger.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};
